// src/components/programs/ProgramForm/Step0Sections/CoverImageSection.jsx

import React from "react";
import { Grid, Box } from "@mui/material";
import FormInput from "../../../inputs/FormInput";

const CoverImageSection = ({
    formData,
    errors,
    isArabic,
    handleCoverImageChange,
    isUploadingCover,
    isEdit,
}) => {
    return (
        <Grid container spacing={3}>
            {/* Cover Image */}
            <Grid item xs={12}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <FormInput
                        label={isArabic ? 'صورة الغلاف' : 'Cover Image'}
                        labelImage={isArabic ? 'اختر صورة الغلاف' : 'Choose cover image'}
                        labelBioImage={
                            isArabic
                                ? 'اسحب وأسقط الصورة هنا أو انقر للاختيار'
                                : 'Drag & drop or click to upload'
                        }
                        type="file"
                        name="cover_image"
                        value={formData.cover_image_preview || ''}
                        onChange={handleCoverImageChange}
                        required={false}
                        isUploading={isUploadingCover}
                        errorMessage={formData.coverImageError}
                        successMessage={formData.coverImageSuccess}
                        width="100%"
                        height="350px"
                        borderRadius="8px"
                        objectFit="cover"
                    />
                </Box>
            </Grid>
        </Grid>
    );
};

export default CoverImageSection;
